import { Box } from 'features/knowledgeDocumentViewer/components/viewer/types'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'
import { KnowledgeDocumentEntry, RolodexEntryType } from 'types'

export const useBoxLinkedDocuments = (
  knowledgeDocumentEntriesForSelectedDocument: KnowledgeDocumentEntry[],
  tooltipBox: Box | null,
  siteID: string
) => {
  const { currentPageNumber, currentDocumentId } =
    useKnowledgeDocumentUXContext()

  const taggedUnit = useMemo(() => {
    if (!tooltipBox) return undefined

    const parsedBoxId = tooltipBox.id.split('-')
    if (parsedBoxId.length !== 2) return undefined
    const boxId = Number(parsedBoxId[0])

    return knowledgeDocumentEntriesForSelectedDocument?.find(
      (document: KnowledgeDocumentEntry) =>
        document.entry.data.fields.instance_id === boxId &&
        document.entry.data.fields.page_number ===
          (tooltipBox.id.includes('-1')
            ? currentPageNumber + 1
            : currentPageNumber)
    )?.entry.tags.unit
  }, [
    currentPageNumber,
    knowledgeDocumentEntriesForSelectedDocument,
    tooltipBox,
  ])

  const { data: connectedKnowledgeDocumentEntries } =
    useGetRolodexEntriesByLoadOptions<KnowledgeDocumentEntry[]>({
      type: [RolodexEntryType.KNOWLEDGE_DOCUMENT],
      tags: {
        site: siteID,
        unit: taggedUnit ?? 'zero-zero',
      },
      limit: 100000,
    })

  const filteredConnectedKnowledgeDocumentEntries = useMemo(() => {
    return connectedKnowledgeDocumentEntries?.filter(
      (entry) => entry.entry.tags['system-document'] !== currentDocumentId
    )
  }, [currentDocumentId, connectedKnowledgeDocumentEntries])

  return {
    connectedKnowledgeDocumentEntries:
      filteredConnectedKnowledgeDocumentEntries ?? [],
    taggedUnit,
  }
}
